{
    "component-card-search-list.empty-state.title.non-final": "<strong>Länka den här lagringsplatsen till en programvarukomponent</strong>",
    "component-card.add-chat-channel": "Lägg till chattkanal",
    "component-card.chat-channels": "Chattkanaler",
    "component-card.expander.show-more-link": "Visa {formattedCount} till"
}
